export default __webpack_public_path__ + "static/media/character3.efc0e959.png";